export default "__VITE_ASSET__68460d4e__"